import axios from 'axios'
import { ElLoading, ElMessage } from 'element-plus'
// 确保引入了cookies（根据你的实际情况调整）
import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

const service = axios.create({
    // 统一设置通用请求头，不再单独区分post
    headers: {
        "Content-Type": "application/json;charset=utf-8"
    },
    timeout: 20000
})

let _loading = null;

service.interceptors.request.use(
    config => {
        // 修复原代码中的无效赋值
        // _config = _config; 这行代码没有意义，已移除
        
        // 显示加载状态
        _loading = ElLoading.service({
            lock: true,
            fullscreen: true,
            spinner: 'el-icon-loading',
            text: "努力加载中..."
        });
        
        // 添加token请求头
        const token = cookies.get('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        // 处理GET请求参数（确保params存在，可添加防缓存参数）
        if (config.method === 'get') {
            // 确保params对象存在
            config.params = config.params || {};
        }

        return config
    },
    error => {
        // 错误时关闭加载
        if (_loading) {
            _loading.close();
            _loading = null;
        }
        ElMessage.error('请求发送失败');
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    res => {
        // 关闭加载
        if (_loading) {
            _loading.close();
            _loading = null;
        }
        
        // 登录过期处理
        if (res.data.code === 401) {
            cookies.remove("token");
            window.location.href = '/';
            ElMessage.warning('登录已过期，请重新登录');
            return Promise.reject(new Error('登录已过期'))
        }
        
        // 业务错误处理
        if (res.status != 200) {
            ElMessage.error(res.data.message || '操作失败')
            return Promise.reject(new Error(res.data || '操作失败'))
        }
        
        return res
    },
    error => {
        // 关闭加载
        if (_loading) {
            _loading.close();
            _loading = null;
        }
        
        // 网络错误提示
        if (error.message.includes('timeout')) {
            ElMessage.error('请求超时，请稍后再试');
        } else if (error.message.includes('Network Error')) {
            ElMessage.error('网络连接错误，请检查网络');
        } else {
            ElMessage.error('请求失败，请稍后再试');
        }
        
        return Promise.reject(error)
    }
)
export default service
